(function() {
    var readerCache = {},
        dummyArray = [];

    SA.createRecords = function(modelName, data) {
        var isArray = Array.isArray(data),
            reader,
            records,
            model;

        if (!modelName || !(model = Ext.ModelManager.getModel(modelName))) {
            throw new Error('Missing model: ' + model);
        }

        if (typeof modelName !== 'string') {
            modelName = model.getName();
        }

        reader = readerCache[modelName] || (readerCache[modelName] = new Ext.data.reader.Json({model}));

        if (!isArray) {
            dummyArray[0] = data;
            data = dummyArray;
        }

        records = reader.extractData([].concat(data));

        if (!isArray) {
            records = records[0];
        }

        return records;
    };
})();

SA.modelConvert = function(modelName) {
    return function(data) {
        if (data) {
            if (data.isModel) {
                return data;
            }

            if (!Ext.isObject(data)) {
                data = {id: data};
            }

            return SA.createRecords(modelName, data);
        }

        return null;
    };
};

SA.modelArrayConvert = function(modelName) {
    return function(data) {
        var newData = [],
            records;

        if (data) {
            if (!Array.isArray(data)) {
                data = [data];
            }

            data.forEach(entry => {
                if (!Ext.isObject(entry)) {
                    entry = {id: entry};
                }

                newData.push(entry);
            });
        }

        records = SA.createRecords(modelName, newData);

        if (data && SA.arraysEqual(records, data)) {
            records = data;
        }

        return records;
    };
};